<template>
  <div>
    <nav-bar/>
    <div class="suggestions-bg">
      <div class="container" id="suggestions">
        <div class="grayBorder my-3">
          <h5 class="text-center py-5 ">انتقاد و پیشنهاد</h5>
          <div class="row p-3">
            <div class="col-12">
              <div class="mt-5 font-16">نوع نظر</div>
              <v-select
                  class="mt-2"
                  :items="commentType"
                  item-value="id"
                  item-text="text"
                  v-model="suggestionType"
                  solo
              ></v-select>
              <div class="mt-5 font-16">موضوع</div>
              <div>
                <v-text-field
                    v-model="subject"
                    class="mt-2"
                    solo
                    hide-details
                    dense
                    single-line
                ></v-text-field>
              </div>
              <div class="mt-5 font-16">متن</div>
              <div>
                <v-textarea
                    v-model="textModel"
                    class="mt-2"
                    solo
                    name="input-7-4"
                ></v-textarea>
              </div>
              <v-btn
                  block
                  color="primary"
                  elevation="0"
                  @click="sendSuggestion">
                انجام
              </v-btn>
            </div>
          </div>

        </div>
      </div>
      <v-dialog
          v-model="showLoaderDialog"
          persistent
          width="500">
        <v-card class="text-center py-5">
          <v-progress-circular
              color="primary"
              indeterminate
          ></v-progress-circular>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showResultDialog"
          persistent
          width="500">
        <v-card class="text-center pt-5">
          <v-card-text class="pb-0">
            <div class="mb-0 black--text">{{ dialogResult }}</div>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pt-1 pb-3">
            <v-btn elevation="0" block class="primary" rounded @click="showResultDialog = !showResultDialog">
              بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>


import NavBar from "@/Ticketing/components/navBar";

export default {
  name: "suggestionsAndCritic",
  components: {NavBar},
  metaInfo: {
    title: 'تیکتینگ -انتقادات و پیشنهاد'
  },
  data: () => ({
    dialogResult: null,
    showLoaderDialog: false,
    showResultDialog: false,
    textModel: null,
    suggestionType: null,
    commentType: [{id: '1', text: 'انتقاد'}, {id: '2', text: 'پیشنهاد'}],
    subject: null,
    setSuggestion: null,
    isLoggedIn: false,
  }),
  mounted() {
    this.$convertFarsiNumber()
  },
  methods: {
    sendSuggestion() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("Description", this.textModel);
      urlencoded.append("Subject", this.subject);
      urlencoded.append("TypeSuggestionCritic", this.suggestionType);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/SuggestionCritic", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.showResultDialog = true
            this.dialogResult = result
          })
          .catch(error => console.log('error', error));
    },

  }
}
</script>

<style scoped>

</style>
